// extracted by mini-css-extract-plugin
export default {"container":"AverageRating_container__njS7F","point":"AverageRating_point__7k0xQ","point__rating":"AverageRating_point__rating__OiYW3","rating":"AverageRating_rating__WicwJ"};